import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequirementService } from '@/services/requirement/requirement.service';
import { CompleteLicenseWithDate } from '@/interfaces/dashboard/licenses';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { deofuscate } from '@/utils/obfuscation';
import { Location } from '@angular/common';

@Component({
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {

  personRutDv?: string;

  licenseId?: number;
  licenseData?: CompleteLicenseWithDate;
  licenseDataGetting: boolean = true;
  licenseDataError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private requirementService: RequirementService,
  ) { }

  get documents(): CompleteLicenseWithDate['documents'] {
    if (this.licenseData) {
      return this.licenseData.documents;
    }
    return [];
  }

  get equipments(): CompleteLicenseWithDate['equipments'] {
    if (this.licenseData) {
      return this.licenseData.equipments;
    }
    return [];
  }

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Solicitar', path: '/license/new' },
  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const { id } = deofuscate(ofuscatedData);
      this.licenseId = id;
      this.requirementService.getDeletedLicenseById(id).subscribe({
        next: (license) => {
          this.licenseData = license;
          this.personRutDv = license.userRutDv;
          this.licenseDataGetting = false;
        },
        error: () => {
          this.licenseDataGetting = false;
          this.licenseDataError = true;
        },
      });
    });
  }

  onGoBack() {
    this.location.back();
  }

}
